/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowDto
 */
export interface ShowDto {
    /**
     * 
     * @type {number}
     * @memberof ShowDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ShowDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ShowDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ShowDto
     */
    deadlineDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    onText1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    onText2?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowDto
     */
    onBooking?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowDto
     */
    announcementLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowDto
     */
    lastStartNo?: number;
}

/**
 * Check if a given object implements the ShowDto interface.
 */
export function instanceOfShowDto(value: object): value is ShowDto {
    return true;
}

export function ShowDtoFromJSON(json: any): ShowDto {
    return ShowDtoFromJSONTyped(json, false);
}

export function ShowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'deadlineDate': json['deadlineDate'] == null ? undefined : (new Date(json['deadlineDate'])),
        'location': json['location'] == null ? undefined : json['location'],
        'city': json['city'] == null ? undefined : json['city'],
        'onText1': json['onText1'] == null ? undefined : json['onText1'],
        'onText2': json['onText2'] == null ? undefined : json['onText2'],
        'onBooking': json['onBooking'] == null ? undefined : json['onBooking'],
        'announcementLink': json['announcementLink'] == null ? undefined : json['announcementLink'],
        'lastStartNo': json['lastStartNo'] == null ? undefined : json['lastStartNo'],
    };
}

export function ShowDtoToJSON(json: any): ShowDto {
    return ShowDtoToJSONTyped(json, false);
}

export function ShowDtoToJSONTyped(value?: ShowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString().substring(0,10)),
        'deadlineDate': value['deadlineDate'] == null ? undefined : ((value['deadlineDate'] as any).toISOString().substring(0,10)),
        'location': value['location'],
        'city': value['city'],
        'onText1': value['onText1'],
        'onText2': value['onText2'],
        'onBooking': value['onBooking'],
        'announcementLink': value['announcementLink'],
        'lastStartNo': value['lastStartNo'],
    };
}

